module.exports = __webpack_public_path__ + "media/images/knockout__winnerDeco@3x-b1e1b1cc1908d63cd0f190cb1464cc4b.png";